<template>
  <div>
    <top-bar heading="Signoff Form" :buttons="buttons"></top-bar>
    <loading-spinner :loading="!loaded"></loading-spinner>
    <div class="container-fluid mt-3 text-center" v-if="loaded && submitted">
      <h3>Signoff Form Completed!</h3>
    </div>
    <div class="container-fluid mt-3" v-if="loaded && !submitted">
      <template v-if="form.form_schema">
        <template v-if="!combined">
          <template v-if="form.student_id === $auth.user().id">
            <b-card no-body header="Student">
              <b-card-body class="p-3">
                <form-viewer :form-id="form.form_id" :schema="form.form_schema.student" v-model="form.form_data" :read-only="false" :on-submit="submitForm"></form-viewer>
              </b-card-body>
            </b-card>
            <b-card no-body header="Supervisor" header-bg-variant="danger">
              <b-card-body class="p-3">
                <form-viewer :form-id="form.form_id" :schema="form.form_schema.supervisor" v-model="form.form_data" :read-only="true" :on-submit="submitForm"></form-viewer>
              </b-card-body>
            </b-card>
            <b-card no-body header="Assessor" header-bg-variant="danger">
              <b-card-body class="p-3">
                <form-viewer :form-id="form.form_id" :schema="form.form_schema.assessor" v-model="form.form_data" :read-only="true" :on-submit="submitForm"></form-viewer>
              </b-card-body>
            </b-card>
          </template>
          <template v-else-if="form.assessor_id === $auth.user().id">
            <b-card no-body header="Assessor">
              <b-card-body class="p-3">
                <form-viewer :form-id="form.form_id" :schema="form.form_schema.assessor" v-model="form.form_data" :read-only="false" :on-submit="submitForm"></form-viewer>
              </b-card-body>
            </b-card>
            <b-card no-body header="Student" header-bg-variant="danger">
              <b-card-body class="p-3">
                <form-viewer :form-id="form.form_id" :schema="form.form_schema.student" v-model="form.form_data" :read-only="true" :on-submit="submitForm"></form-viewer>
              </b-card-body>
            </b-card>
            <b-card no-body header="Supervisor" header-bg-variant="danger">
              <b-card-body class="p-3">
                <form-viewer :form-id="form.form_id" :schema="form.form_schema.supervisor" v-model="form.form_data" :read-only="true" :on-submit="submitForm"></form-viewer>
              </b-card-body>
            </b-card>
          </template>
          <template v-else-if="form.supervisor_id === $auth.user().id">
            <b-card no-body header="Supervisor">
              <b-card-body class="p-3">
                <form-viewer :form-id="form.form_id" :schema="form.form_schema.supervisor" v-model="form.form_data" :read-only="false" :on-submit="submitForm"></form-viewer>
              </b-card-body>
            </b-card>
            <b-card no-body header="Assessor" header-bg-variant="danger">
              <b-card-body class="p-3">
                <form-viewer :form-id="form.form_id" :schema="form.form_schema.assessor" v-model="form.form_data" :read-only="true" :on-submit="submitForm"></form-viewer>
              </b-card-body>
            </b-card>
            <b-card no-body header="Student" header-bg-variant="danger">
              <b-card-body class="p-3">
                <form-viewer :form-id="form.form_id" :schema="form.form_schema.student" v-model="form.form_data" :read-only="true" :on-submit="submitForm"></form-viewer>
              </b-card-body>
            </b-card>
          </template>
        </template>
        <template v-else>
          <b-card no-body header="Signoff">
            <b-card-body class="p-3">
              <form-viewer :form-id="form.form_id" :schema="form.form_schema.combined" v-model="form_data" :on-submit="submitForm"></form-viewer>
            </b-card-body>
          </b-card>
        </template>
      </template>
      <template v-else>
        <div class="alert alert-danger">Unexpected Error Occurred</div>
      </template>
    </div>
  </div>
</template>

<script>
import FormViewer from '../../components/FormViewer/FormViewer'

export default {
  name: 'SignoffFormsFill',
  components: { FormViewer },
  data () {
    return {
      loaded: false,
      submitted: false,
      combined: false,
      form_data: {},
      form: {
        form_schema: {},
        form_data: []
      }
    }
  },
  computed: {
    buttons () {
      return [
        {
          access: this.$auth.check(['rto', 'rto_trainer', 'admin', 'super_admin']) && !this.combined,
          label: 'Switch to Combined',
          click: () => {
            this.combined = true
          }
        },
        {
          access: this.$auth.check(['rto', 'rto_trainer', 'admin', 'super_admin']) && this.combined,
          label: 'Switch to Seperate',
          click: () => {
            this.combined = false
          }
        }
      ]
    }
  },
  methods: {
    getForm () {
      this.axios.get('/signoff/' + this.id).then(rsp => {
        this.loaded = true

        let form = rsp.data.data
        form.form_schema.combined = { components: [] }
        form.form_schema.combined.components = [...form.form_schema.assessor.components.filter((s) => s.type !== 'button'),...form.form_schema.student.components.filter((s) => s.type !== 'button'), ...form.form_schema.supervisor.components]

        this.form = Object.assign(this.form, form)

      }).catch(err => this.$errorOut(err))
    },
    submitForm () {
      return new Promise((resolve, reject) => {
        this.loaded = false

        this.axios.put('/signoff/' + this.id, { form_data: this.form.form_data, combined: this.combined ? 1 : 0 }).then(() => {
          this.$swal('Success', 'Form has been submitted', 'success')
          resolve()
          this.loaded = true
          this.submitted = true
          this.$store.dispatch('LOAD_MY_SIGNOFF_FORMS', this)
        }).catch(err => {
          this.$swal('Error', err.response.data.message, 'error')
          this.loaded = true
          reject()
        })
      })
    }
  },
  mounted () {
    this.getForm()
  },
  metaInfo: {
    title: 'Signoff Form'
  },
  props: ['id']
}
</script>
